"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _availability = require("../../config/availability");

var _de = _interopRequireDefault(require("../../locals/de.json"));

var _en = _interopRequireDefault(require("../../locals/en.json"));

var _it = _interopRequireDefault(require("../../locals/it.json"));

var _Availability = _interopRequireDefault(require("./Availability.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Availability = function Availability(_ref) {
  var _clsx;

  var count = _ref.count,
      isAvailable = _ref.isAvailable,
      lang = _ref.lang;
  var css = (0, _Availability.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  var state = (0, _react.useMemo)(function () {
    if (!isAvailable) {
      return {
        label: l("reactShop.availability.stateError"),
        type: "error"
      };
    }

    if (count === 0) {
      return {
        label: l("reactShop.availability.stateError"),
        type: "error"
      };
    } else if (count > 0 && count <= _availability.AVAILABILITY_THRESHOLD) {
      return {
        label: l("reactShop.availability.stateWarning", {
          count: count
        }),
        type: "warning"
      };
    } else {
      return {
        label: l("reactShop.availability.stateSuccess"),
        type: "success"
      };
    }
  }, [count, isAvailable, l]);
  if (typeof count === "undefined") return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx2.default)(css.availability, (_clsx = {}, _defineProperty(_clsx, css.availabilityError, (state === null || state === void 0 ? void 0 : state.type) === "error"), _defineProperty(_clsx, css.availabilitySuccess, (state === null || state === void 0 ? void 0 : state.type) === "success"), _defineProperty(_clsx, css.availabilityWarning, (state === null || state === void 0 ? void 0 : state.type) === "warning"), _clsx), "mco-shop-availability")
  }, state === null || state === void 0 ? void 0 : state.label);
};

var _default = Availability;
exports.default = _default;